var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('preview',{attrs:{"ad-count":2,"edited-business-details":_vm.editedBusinessDetails}})}
var staticRenderFns = []

export { render, staticRenderFns }